import dayjs from 'dayjs';
import { warsawTodayYmd } from '@ip/shared-types';

/**
 * Today's Warsaw calendar day as a Date at LOCAL midnight — the shape the
 * DatePicker holds, so `dayjs(d).format('YYYY-MM-DD')` reads it back as that
 * day wherever the browser runs.
 */
export function warsawToday(): Date {
  return dayjs(warsawTodayYmd()).toDate();
}

/**
 * True for a picked date after today in Europe/Warsaw — the backend's
 * "not later than today" rule (payments, combined payments, statements),
 * which a browser clock in another time zone would otherwise misjudge
 * around midnight.
 */
export function isAfterWarsawToday(d: Date): boolean {
  return dayjs(d).format('YYYY-MM-DD') > warsawTodayYmd();
}
